export default "__VITE_PUBLIC_ASSET__d359a15a__"